import axiosClient from '../http/axios.client';

// Explicit nested population keeps these requests independent of the legacy API.
export function industryQuery(slug) {
  const params = new URLSearchParams({
    'populate[hero][populate]': 'image',
    'populate[sections][populate][image]': 'true',
    'populate[sections][populate][items][populate]': 'image',
    'populate[seo]': 'true',
  });
  if (slug) params.set('filters[slug][$eq]', slug);
  return params.toString();
}

export async function getIndustryPage(slug, signal) {
  const endpoint = slug ? '/industry-pages' : '/industry-landing';
  try {
    const { data } = await axiosClient.get(`${endpoint}?${industryQuery(slug)}`, {
      signal,
      timeout: 15000,
    });
    return slug ? data?.data?.[0] ?? null : data?.data ?? null;
  } catch (error) {
    if (error.response?.status === 404) return null;
    throw error;
  }
}

export function mediaUrl(image) {
  if (!image?.url) return '';
  const base = new URL(axiosClient.defaults.baseURL, window.location.origin);
  try {
    const url = new URL(image.url, base.origin);
    return ['http:', 'https:'].includes(url.protocol) ? url.href : '';
  } catch { return ''; }
}

export function safeLink(value) {
  if (typeof value !== 'string' || /[\s\\]/.test(value)) return null;
  if (/^\/(?!\/)/.test(value) || /^#[\w-]+$/.test(value)) return value;
  try {
    const url = new URL(value);
    return ['https:', 'http:', 'mailto:', 'tel:'].includes(url.protocol) ? value : null;
  } catch { return null; }
}
